angular
	.module('empower.userProfile')
	.constant('userProfileConst', {
		PREFERRED_CONTACT_NUMNER: [
			{ id : 0 , name : 'Home' },
			{ id : 1 , name : 'Work' },
			{ id : 2 , name : 'Mobile' }		
        ],
        PREFERRED_METHOD_COMMUNICATION: [
			{ id : 0 , name : 'Phone' },
			{ id : 1 , name : 'Email' }			
        ],
        PREFERRED_TIME_TO_CONTACT: [
			{ id : 0 , name : 'Morning (8:30AM - noon)' },
			{ id : 1 , name : 'Afternoon (noon - 5PM)' }			
		]
	});